export default __webpack_public_path__ + "static/media/1_Mockup_1.b00d5e4e.mp4";